/* presence-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdWVPG%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pp6NdYbGa%7Bpointer-events%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VxpxF%7Bheight%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02xpxF%7Bwidth%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VEbN9%7Bheight%3A14px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02EbN9%7Bwidth%3A14px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0V2sAl%7Bheight%3A15px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV022sAl%7Bwidth%3A15px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0V70UD%7Bheight%3A18px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV0270UD%7Bwidth%3A18px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Bm75GdnbC%7Bbottom%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ApkO2dnbC%7Bright%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Bm75GHZdu%7Bbottom%3A1px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ApkO2HZdu%7Bright%3A1px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Bm75GXJux%7Bbottom%3A7px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ApkO2XJux%7Bright%3A7px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Bm75GVo9d%7Bbottom%3A-4px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ApkO2Vo9d%7Bright%3A-4px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Bm75GA17z%7Bbottom%3A-1px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ApkO2A17z%7Bright%3A-1px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Bm75GUNDJ%7Bbottom%3A4px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Bm75GvFgp%7Bbottom%3A17px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ApkO28e2l%7Bright%3A-5px%7D");
import { type FC } from 'react';
import AvatarPresence, { type PresenceProps } from '../presence';
import { type AppearanceType, type IndicatorSizeType } from '../types';
interface PresenceWrapperProps extends PresenceProps {
  appearance: AppearanceType;
  size: IndicatorSizeType;
  testId?: string;
}
const styles = {
  root: "_1mT5xdWVPG _1pp6NdYbGa"
};
const iconSizeMap = {
  small: "_0jFU0VxpxF _39xV02xpxF",
  medium: "_0jFU0VEbN9 _39xV02EbN9",
  large: "_0jFU0V2sAl _39xV022sAl",
  xlarge: "_0jFU0V70UD _39xV0270UD"
};
const circleIconOffsetMap = {
  small: "_0Bm75GdnbC _4ApkO2dnbC",
  medium: "_0Bm75GdnbC _4ApkO2dnbC",
  large: "_0Bm75GHZdu _4ApkO2HZdu",
  xlarge: "_0Bm75GXJux _4ApkO2XJux"
};
const squareIconOffsetMap = {
  root: "_0Bm75GVo9d _4ApkO2Vo9d"
};
const hexagonIconOffsetMap = {
  small: "_0Bm75GA17z _4ApkO2A17z",
  medium: "_0Bm75GA17z _4ApkO2A17z",
  large: "_0Bm75GUNDJ _4ApkO2Vo9d",
  xlarge: "_0Bm75GvFgp _4ApkO28e2l"
};

/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */
const PresenceWrapper: FC<PresenceWrapperProps> = ({
  size,
  appearance,
  children,
  borderColor,
  presence,
  testId
}) => {
  return <span aria-hidden="true" data-testid={testId && `${testId}--presence`} className={ax([styles.root, iconSizeMap[size], circleIconOffsetMap[size], appearance === 'square' && squareIconOffsetMap.root, appearance === 'hexagon' && hexagonIconOffsetMap[size]])}>
			<AvatarPresence borderColor={borderColor} presence={!children ? presence : undefined}>
				{children}
			</AvatarPresence>
		</span>;
};
export default PresenceWrapper;